export default __webpack_public_path__ + "static/media/NovoVisaoGeral.ad835e13.svg";